module.exports = __webpack_public_path__ + "img/share-icon.b871d0a1.png";